<script lang="ts">
	import Link from '$internal/components/link/Link.svelte';

	export let href: string;
	export let title: string = href;
	export let rel = '';
</script>

<Link {href} {title} {rel}><slot /></Link>
